/**
 * Newsletter signup page — the subscribe card's three subscription toggles.
 * ------------------------------------------------------------------------
 * Rendered by `inc/gutenberg/blocks/newsletter-subscribe-card/render.php`.
 *
 * The visible checkboxes deliberately carry no `name`; they are UI only. The
 * plugin submits with `new FormData(this.form)`, so only fields that live inside
 * its own <form class="multi-step-form"> are ever sent. This module therefore
 * keeps a set of hidden mirror inputs inside that form and rewrites them on every
 * change. `inc/hooks/ehf-newsletter-interests.php` reads them server-side and maps
 * each key onto its HubSpot contact property.
 *
 * Mirroring is used rather than moving the toggle markup into the form, or leaning
 * on the HTML `form=""` association attribute, because it leaves the design's
 * layout alone and is obvious when you inspect the DOM.
 *
 * With JS off nothing is mirrored, the submission carries no interest keys, and
 * the hook leaves all three properties untouched — we never assert a subscription
 * the visitor did not actually confirm.
 */
(function () {
  'use strict';

  var FIELD_NAME = 'nl_interest[]';

  /** "A", "A and B", "A, B and C" */
  function joinNames(names) {
    if (names.length <= 1) {
      return names[0] || '';
    }
    return names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1];
  }

  function initCard(root) {
    var options = Array.prototype.slice.call(root.querySelectorAll('.nl-opt'));

    if (!options.length) {
      return;
    }

    var form = root.querySelector('form.multi-step-form');
    var submit = root.querySelector('[data-ehf-role="submit-form"]');
    var panel = root.querySelector('[data-nl-panel]');
    var done = root.querySelector('[data-nl-done]');
    var doneLine = root.querySelector('[data-nl-done-line]');

    // One container for every mirror, so a re-sync is a single innerHTML write
    // and can never leave a stale key behind.
    var mirrors = null;

    if (form) {
      mirrors = document.createElement('span');
      mirrors.className = 'nl-subscribe__mirrors';
      mirrors.hidden = true;
      form.appendChild(mirrors);
    }

    function selected() {
      return options
        .map(function (option) {
          var input = option.querySelector('.nl-opt__input');
          var title = option.querySelector('.nl-opt__title');

          return input && input.checked
            ? { key: input.value, name: title ? title.textContent.trim() : input.value }
            : null;
        })
        .filter(Boolean);
    }

    function sync() {
      var chosen = selected();

      // Reflect state onto the label so the design's selected treatment (teal
      // border, tinted fill, lime tick) is a pure CSS concern.
      options.forEach(function (option) {
        var input = option.querySelector('.nl-opt__input');
        option.classList.toggle('is-on', !!(input && input.checked));
      });

      if (mirrors) {
        mirrors.innerHTML = '';

        chosen.forEach(function (item) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = FIELD_NAME;
          input.value = item.key;
          mirrors.appendChild(input);
        });
      }

      if (submit) {
        if (!chosen.length) {
          submit.textContent = 'Select a subscription';
          submit.disabled = true;
        } else {
          submit.textContent = chosen.length === 1
            ? 'Subscribe'
            : 'Subscribe to ' + chosen.length + ' lists';
          submit.disabled = false;
        }
      }
    }

    options.forEach(function (option) {
      var input = option.querySelector('.nl-opt__input');

      if (input) {
        input.addEventListener('change', sync);
      }
    });

    /*
     * The plugin dispatches ehfSubmissionSuccess on its .ehf-container, which sits
     * inside this card, so the event reaches us on the way up. The chosen list is
     * read before the panel is swapped — after that the checkboxes are gone from
     * view and their state is no longer meaningful to the visitor.
     */
    root.addEventListener('ehfSubmissionSuccess', function () {
      var chosen = selected();

      if (doneLine && chosen.length) {
        var template = doneLine.getAttribute('data-nl-done-template') || '';

        if (template) {
          doneLine.textContent = template.replace(
            '{lists}',
            joinNames(chosen.map(function (item) { return item.name; }))
          );
        }
      }

      if (panel && done) {
        panel.hidden = true;
        done.hidden = false;
        // Move focus so the confirmation is announced rather than silently swapped.
        done.setAttribute('tabindex', '-1');
        done.focus();
      }
    });

    sync();
  }

  function init() {
    document.querySelectorAll('[data-nl-subscribe]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
